import React from "react";
import "./FinalCTA.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const FinalCTA = () => {
  return (
    <section className="oglitz-final-cta">
      <div className="oglitz-final-cta-inner">
        {/* CONTENT */}
        <div className="oglitz-final-cta-content">
          <span className="oglitz-final-cta-badge">Ready to Start?</span>

          <h2>
            Let’s Build Something <span>Impactful</span> Together
          </h2>

          <p>
            Talk directly with our experts and explore how Oglitz Software can
            help you design, build, and scale secure digital solutions across
            India and the Middle East.
          </p>

          {/* ACTIONS */}
          <div className="oglitz-final-cta-actions">
            <a
              href="https://wa.me/919532119007"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-primary"
            >
              <WhatsAppIcon />
              WhatsApp Us
            </a>

            <a href="/contact" className="cta-secondary">
              Start a Project
              <ArrowForwardIcon />
            </a>
          </div>

          {/* TRUST */}
          <div className="oglitz-final-cta-trust">
            <span>✔ WhatsApp preferred for quick response</span>
            <span>✔ Your data is 100% secure</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
